var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnDutyToday(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0V3H14V0H16V3H20V21H0V3H4V0H6ZM2 5V8H18V5H2ZM18 10H2V19H18V10Z",
    fill: "#4CBDC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9139 12.2499L9.25692 17.9069L5.72192 14.3709L7.13592 12.9569L9.25692 15.0779L13.4999 10.8359L14.9139 12.2499Z",
    fill: "#4CBDC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnDutyToday);
export default __webpack_public_path__ + "static/media/on_duty_today.eec78271a75e335e2c3671f16a795b6f.svg";
export { ForwardRef as ReactComponent };